/**
 * Инициализация виджетов страницы оформления заказа:
 *  - выбор населённого пункта и магазина (tom-select)
 *  - маска телефонных полей (inputmask)
 *
 * Подключается в application/views/frontend/cart/new_index.php.
 */
(function () {
    'use strict';

    const SELECT_LOCATION_ID = 'select-location';
    const SELECT_SHOP_ID = 'select-shop';
    /** value радио «Из магазина» в name="type_delivery"; «Курьером» — 2 */
    const PICKUP_DELIVERY = '4';

    /**
     * Язык берём из скрытого поля формы, с запасным вариантом по URL.
     */
    function getLang() {
        const langInput = document.querySelector('.cart_form_send input[name="lang"]');
        if (langInput && langInput.value) {
            return langInput.value;
        }

        const segment = window.location.pathname.split('/')[1];
        if (segment) {
            return segment;
        }

        return 'ro';
    }

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    }

    /**
     * Сообщает бэкенду выбранный город, чтобы он попал в сессию.
     */
    function saveCity(cityId) {
        if (!cityId) {
            return;
        }

        setCookie('select_location', cityId, 1);
        fetch('/' + getLang() + '/ajax/set_city/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: 'value=' + encodeURIComponent(cityId)
        });
    }

    function getSelectValue(id) {
        const el = document.getElementById(id);
        if (!el || !el.tomselect) {
            return '';
        }

        return el.tomselect.getValue();
    }

    /**
     * Выбран ли «Из магазина» (type_delivery = 4).
     */
    function isPickupSelected() {
        const pickupRadio = document.querySelector('.cart_form_send input[name="type_delivery"][value="' + PICKUP_DELIVERY + '"]');

        return !!(pickupRadio && pickupRadio.checked);
    }

    /**
     * Пока не выбран город (курьер) или магазин (самовывоз), форма подсвечена классом focus:
     * страница затемнена и под списком видна подсказка — «Район доставки …?» или «Выберите магазин».
     */
    function onSelectChange() {
        const wrapper = document.querySelector('.switcher-content');
        if (!wrapper) {
            return;
        }

        // В пустой корзине выбирать город / магазин незачем — не затемняем страницу
        if (!document.querySelector('.cart_form_send .block-product')) {
            wrapper.classList.remove('focus');
            return;
        }

        const selectId = isPickupSelected() ? SELECT_SHOP_ID : SELECT_LOCATION_ID;
        if (!getSelectValue(selectId)) {
            wrapper.classList.add('focus');
            return;
        }

        wrapper.classList.remove('focus');
        // Пересчёт доставки живёт в retail_rocket_new_cart.js; пока его нет —
        // просто пропускаем, чтобы не ронять инициализацию.
        if (typeof window.calcDeliveryPrice === 'function') {
            window.calcDeliveryPrice();
        }
    }

    /** Номер последнего запроса доставок: ответы на устаревшие запросы отбрасываем */
    let deliveryListRequestId = 0;
    /**
     * Запрашивает варианты доставки для города у курьерского сервиса.
     * Результат уходит в событие cart:delivery-list на document:
     * detail = { cityId, success, data } или { cityId, success: false, message, errors }.
     */
    function loadDeliveryList(cityId) {
        if (!cityId) {
            return Promise.resolve(null);
        }

        deliveryListRequestId++;
        const requestId = deliveryListRequestId;
        return fetch('/ajax/cart/delivery/list/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: 'city_id=' + encodeURIComponent(cityId) + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0) + '&lang=' + encodeURIComponent(getLang())
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                if (requestId !== deliveryListRequestId) {
                    return null;
                }

                // Ответ в том же формате, что update-all-products-state: суммы + delivery_list.
                // При самовывозе итоги считает loadStoreTotals — курьерские не рисуем
                if (!isPickupSelected()) {
                    renderOrderTotals(result);
                }

                document.dispatchEvent(new CustomEvent('cart:delivery-list', {
                    detail: Object.assign({ cityId: cityId }, result)
                }));

                return result;
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось получить список доставок', error);

                return null;
            });
    }

    /**
     * Город выбран в списке — сохраняем его в сессию и запрашиваем доставки.
     */
    function onLocationChange(cityId) {
        saveCity(cityId);
        refreshDelivery(cityId);
        onSelectChange();
    }

    /** Номер последнего запроса итогов самовывоза: ответы на устаревшие запросы отбрасываем */
    let storeTotalsRequestId = 0;

    /**
     * Итоги корзины при самовывозе: POST /{lang}/ajax/set_cart_store/ (Ajax::set_cart_store).
     * Бэкенд запоминает магазин в сессии (cart_store_id) и считает доставку в магазин
     * по StoreDeliveryStrategy — как при оформлении заказа. Без магазина доставка не считается.
     */
    function loadStoreTotals() {
        const shopId = getSelectValue(SELECT_SHOP_ID);
        if (shopId) {
            setCookie('select_shop', shopId, 1);
        }

        storeTotalsRequestId++;
        const requestId = storeTotalsRequestId;

        return withLoading(fetch('/' + getLang() + '/ajax/set_cart_store/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: 'value=' + encodeURIComponent(shopId)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                // Итоги подставляем до снятия блюра
                if (requestId === storeTotalsRequestId) {
                    renderOrderTotals(result);
                }

                return result;
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось посчитать самовывоз', error);

                return null;
            }));
    }

    /**
     * Магазин выбран в списке.
     */
    function onShopChange() {
        loadStoreTotals();
        syncProductsPickupText();
        onSelectChange();
    }

    /**
     * Текст под товаром вместо способов доставки (их при самовывозе прячет style_cart.css по type_delivery = 4),
     * как в старой корзине: магазин не выбран — «Выберите магазин»; в выбранном магазине хватает товара
     * (data-stock товара { store_id: quantity } против количества в .qty-value) — «Можно забрать через 3 часа»,
     * иначе — «через 48 часов». При курьере пусто (блок скрыт).
     */
    function syncProductsPickupText() {
        const isPickup = isPickupSelected();
        const shopId = isPickup ? getSelectValue(SELECT_SHOP_ID) : '';

        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const title = product.querySelector('.stockValueTitle');
            if (!title) {
                return;
            }

            if (!isPickup) {
                title.textContent = '';
            } else if (!shopId) {
                title.textContent = title.dataset.selectShop || '';
            } else {
                title.textContent = getProductStoreStock(product, shopId) >= getProductQuantity(product)
                    ? (title.dataset.pickup3h || '')
                    : (title.dataset.pickup48h || '');
            }
        });
    }

    /**
     * Остаток товара в магазине из data-stock (cart_product_item.php); нет записи — 0.
     */
    function getProductStoreStock(product, shopId) {
        try {
            const stock = JSON.parse(product.dataset.stock || '{}');

            return Number(stock[shopId]) || 0;
        } catch (error) {
            return 0;
        }
    }

    /**
     * Количество товара в корзине из .qty-value.
     */
    function getProductQuantity(product) {
        const input = product.querySelector('.qty-value');

        return input ? (parseInt(input.value, 10) || 1) : 1;
    }

    /**
     * «Курьером» / «Из магазина»: запоминаем выбор, при самовывозе прячем шаг «Адрес доставки»
     * и открываем следующий, затем подсвечиваем незаполненный город или магазин.
     */
    function initDeliveryTypeSwitch() {
        document.querySelectorAll('.cart_form_send input[name="type_delivery"]').forEach(function (radio) {
            radio.addEventListener('change', function () {
                const isPickup = isPickupSelected();
                setCookie('type_delivery', radio.value, 1);

                const steps = getCheckoutSteps();
                if (steps.length > 1) {
                    steps[0].classList.toggle('uk-hidden', isPickup);
                    openCheckoutStep(isPickup ? 1 : 0);
                }

                syncPickupCheckoutFields(isPickup);
                syncProductsPickupText();
                onSelectChange();
                renderDeliveryProgress();

                // Итоги по новому способу: самовывоз — по магазину, курьер — по выбранным у товаров доставкам
                if (isPickupSelected()) {
                    loadStoreTotals();
                } else if (!loadDeliveryPrice()) {
                    refreshDelivery(getSelectValue(SELECT_LOCATION_ID));
                }
            });
        });
    }

    /**
     * Подсказка «Выберите магазин»: «Выбрать» открывает список магазинов.
     * Саму подсказку закрывает UIkit по классу uk-alert-close.
     */
    function initShopConfirm() {
        const yesButton = document.querySelector('.alert-shop .yes');
        if (!yesButton) {
            return;
        }

        yesButton.addEventListener('click', function (event) {
            event.preventDefault();

            const el = document.getElementById(SELECT_SHOP_ID);
            if (el && el.tomselect) {
                el.tomselect.focus();
                el.tomselect.open();
            }
        });
    }

    /**
     * Доставки для города: блюр на время запроса, затем способы доставки у каждого товара.
     * Итоги обновляет сам loadDeliveryList. Снятые товары сервис не возвращает — их блоки очищаются.
     */
    function refreshDelivery(cityId) {
        if (!cityId) {
            return;
        }

        // Рисуем до снятия блюра, чтобы не мелькала старая разметка
        withLoading(loadDeliveryList(cityId).then(function (result) {
            renderAllProductsDelivery(result);

            return result;
        }));
    }

    const tomSelectOptions = {
        create: false,
        maxOptions: 2000,
        closeAfterSelect: true,
        selectOnTab: true,
        plugins: ['dropdown_input'],
        render: {
            no_results: function (data, escape) {
                return '<div class="no-results">' + escape(data.input) + '</div>';
            }
        }
    };

    function initSelect(id, onChange) {
        const el = document.getElementById(id);
        if (!el || el.tomselect) {
            return;
        }

        new TomSelect(el, Object.assign({}, tomSelectOptions, { onChange: onChange }));
    }

    function initSelects() {
        if (typeof TomSelect === 'undefined') {
            console.warn('cart_checkout: tom-select не загружен');

            return;
        }

        initSelect(SELECT_LOCATION_ID, onLocationChange);
        initSelect(SELECT_SHOP_ID, onShopChange);
        onSelectChange();
        syncProductsPickupText();

        // Город из сессии уже отмечен в списке (selected) — доставки нужны сразу
        refreshDelivery(getSelectValue(SELECT_LOCATION_ID));

        // Страница открыта с самовывозом (cookie type_delivery) — итоги по магазину
        if (isPickupSelected()) {
            loadStoreTotals();
        }
    }

    function initPhoneInputs() {
        const inputs = document.querySelectorAll('.cart_form_send .tel');
        if (!inputs.length) {
            return;
        }

        const maskOptions = {
            mask: '9{1}0{7,12}',
            definitions: {
                '9': { validator: '[1-9]' },
                '0': { validator: '[0-9]' }
            }
        };

        if (typeof window.jQuery !== 'function' || !window.jQuery.fn.inputmask) {
            console.warn('cart_checkout: inputmask не загружен');

            return;
        }

        inputs.forEach(function (telInput) {
            window.jQuery(telInput).inputmask(maskOptions);
        });
    }

    /**
     * Определяет город покупателя (сессия или геолокация по IP)
     * и подставляет его в подсказку «Район доставки».
     */
    function loadAutomaticCity() {
        const citySpan = document.querySelector('.alert-location .location-city');
        if (!citySpan) {
            return;
        }

        fetch('/' + getLang() + '/ajax/set_city_automatically/', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (!data || !data.response || !data.city) {
                    return;
                }

                citySpan.textContent = data.city;
                detectedCityId = findCityIdByName(data.city);
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось определить город', error);
            });
    }

    /** id города, определённого автоматически; его подставляет кнопка «Да» */
    let detectedCityId = '';
    /**
     * id населённого пункта по названию из option[data-name].
     */
    function findCityIdByName(cityName) {
        const options = document.querySelectorAll('#' + SELECT_LOCATION_ID + ' option[data-name]');
        for (let i = 0; i < options.length; i++) {
            if (options[i].dataset.name === cityName) {
                return options[i].value;
            }
        }

        return '';
    }

    /**
     * Подсказка «Район доставки …?»: «Да» выбирает определённый город,
     * «Сменить» открывает список городов. Саму подсказку закрывает UIkit
     * по классу uk-alert-close.
     */
    function initLocationConfirm() {
        const notButton = document.querySelector('.alert-location .not');
        if (notButton) {
            notButton.addEventListener('click', function (event) {
                event.preventDefault();

                const el = document.getElementById(SELECT_LOCATION_ID);
                if (el && el.tomselect) {
                    el.tomselect.focus();
                    el.tomselect.open();
                }
            });
        }

        const yesButton = document.querySelector('.alert-location .yes');
        if (!yesButton) {
            return;
        }

        yesButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (!detectedCityId) {
                return;
            }

            const el = document.getElementById(SELECT_LOCATION_ID);
            if (el && el.tomselect) {
                // Без события onChange, чтобы set_city ушёл ровно один раз
                el.tomselect.addItem(detectedCityId, true);
            }

            onLocationChange(detectedCityId);
        });
    }

    /**
     * Отправляет изменение корзины на /cart/update.
     * Ответ уходит в событие cart:updated на document (detail — ответ сервера).
     */
    /** Сколько запросов /cart/update ещё в пути: блюр итогов снимаем после последнего */
    let pendingCartUpdates = 0;

    /** Блоки, которые размываются, пока корзина пересчитывается: итоги и список товаров */
    const LOADING_BLOCK_SELECTORS = ['.cart-total-block', '.b-items'];

    /**
     * Размывает итоги и список товаров, пока корзина пересчитывается.
     */
    function setTotalsLoading(isLoading) {
        LOADING_BLOCK_SELECTORS.forEach(function (selector) {
            const block = document.querySelector(selector);
            if (block) {
                block.classList.toggle('is-loading', isLoading);
            }
        });
    }

    /**
     * Отмечает или снимает все товары корзины разом.
     */
    function updateAllProductsState(isChecked) {
        return sendCartUpdate(
            'cart/update-all-products-state/',
            'application/x-www-form-urlencoded',
            'checked=' + (isChecked ? 1 : 0) + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0)
        );
    }

    /**
     * Отмечен ли «Ridicare la etaj» — от него зависит цена подъёма на этаж.
     */
    function isLiftFloorChecked() {
        const liftFloor = document.querySelector('.cart_form_send input[name="lift_floor"]');

        return !!(liftFloor && liftFloor.checked);
    }

    /**
     * Общая отправка изменений корзины: блюр итогов на время запроса,
     * ответ уходит в событие cart:updated.
     */
    /**
     * Держит блюр, пока идёт запрос. Счётчик общий для всех запросов:
     * блюр снимается после последнего ответа.
     */
    function withLoading(request) {
        pendingCartUpdates++;
        setTotalsLoading(true);

        const done = function () {
            pendingCartUpdates--;
            if (pendingCartUpdates === 0) {
                setTotalsLoading(false);
            }
        };

        return request.then(function (result) {
            done();

            return result;
        }, function (error) {
            done();

            throw error;
        });
    }

    /**
     * onResult(result) вызывается до снятия блюра — чтобы страница обновилась, пока блоки размыты.
     */
    function sendCartUpdate(path, contentType, body, onResult) {
        return withLoading(fetch('/' + getLang() + '/' + path, {
            method: 'POST',
            headers: {
                'Content-Type': contentType,
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                if (typeof onResult === 'function') {
                    onResult(result);
                }

                document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));

                return result;
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось обновить корзину', error);
            }));
    }

    /**
     * Число с пробелами между разрядами, как numberFormat() в PHP: 34999 → «34 999».
     */
    function formatPrice(value) {
        const number = Math.round(Number(value) || 0);

        return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function setText(selector, text) {
        const el = document.querySelector('.cart-total-block ' + selector);
        if (el) {
            el.textContent = text;
        }
    }

    /**
     * Подставляет суммы из ответа update-all-products-state в блок итогов.
     * Ответы /cart/update приходят в другом формате — их пропускаем.
     */
    /** Последний ответ с итогами: при вводе баллов Bomba Club итоги перерисовываются из него без запроса */
    let lastOrderTotals = null;

    function renderOrderTotals(result) {
        if (!result || !result.success || !('total_product_price' in result)) {
            return;
        }

        lastOrderTotals = result;

        setText('.product-total-price', formatPrice(result.total_product_price));
        setText('.services-total-price', formatPrice(result.total_services_price));
        setText('.product-total-discount', '−' + formatPrice(result.total_discount_price));
        setText('.order-getting-up-price', formatPrice(result.total_price_getting_up));
        // Подъём на этаж доступен (delivery_list.data.getting_up_data.enable_option) — .block-lift-floor
        // виден только с lift-floor-enabled (new_cart.css). Без доставки (самовывоз, нет города) — недоступен
        if ('getting_up_enabled' in result) {
            const wrapper = document.querySelector('.switcher-content');
            if (wrapper) {
                wrapper.classList.toggle('lift-floor-enabled', !!result.getting_up_enabled);
                // Подъём бесплатный (цена 0): у галочки надпись «Подъём на этаж бесплатный»
                wrapper.classList.toggle('lift-floor-free', !!result.getting_up_enabled && !!result.getting_up_free);
            }
        }

        // Цена подъёма уходит в заказ (RetailRocketCheckout: price_lift_floor)
        const liftFloorPrice = document.getElementById('price_lift_floor');
        if (liftFloorPrice) {
            liftFloorPrice.value = Math.round(Number(result.total_price_getting_up) || 0);
        }
        setText('.order-total-cashback', formatPrice(result.total_cashback));

        // Сервер перепроверяет промокод по отмеченным товарам: переставший подходить пропадает и здесь.
        // До итога: с промокодом баллы Bomba Club сбрасываются
        if ('applied_promo' in result) {
            renderPromoState(result.applied_promo);
        }

        // Сколько баллов можно снять, зависит от отмеченных товаров
        if ('uds_max_points' in result) {
            syncUdsMaxPoints(result.uds_max_points);
        }

        // Итог — с баллами Bomba Club, которые ввёл покупатель (в заказ уходят uds_code_y)
        const udsPoints = getUdsPoints();
        setText('.order-uds-points', formatPrice(udsPoints));
        const udsRow = document.querySelector('.cart-total-block .price_uds_points');
        if (udsRow) {
            udsRow.classList.toggle('uk-hidden', udsPoints <= 0);
        }
        setText('.order-total-price', formatPrice(Math.max(0, (Number(result.total_cart) || 0) - udsPoints)));

        // Доставка приходит числом (цена) или готовым текстом (например «Gratuit»)
        const delivery = document.querySelector('.cart-total-block .order-delivery');
        if (delivery) {
            const deliveryPrice = result.total_delivery_price;
            const isNumeric = deliveryPrice !== '' && deliveryPrice !== null && !isNaN(Number(deliveryPrice));

            if (isNumeric && Number(deliveryPrice) > 0) {
                delivery.textContent = formatPrice(deliveryPrice) + ' ' + (delivery.dataset.currency || '');
            } else if (!isNumeric && deliveryPrice) {
                delivery.textContent = deliveryPrice;
            } else {
                delivery.textContent = delivery.dataset.freeText || '';
            }
        }

        if (result.pickup_free_delivery) {
            lastPickupFreeDelivery = result.pickup_free_delivery;
        }
        renderDeliveryProgress();
    }

    /**
     * Самовывоз из ответа set_cart_store (pickup_free_delivery): { delivered_from_another_store, free_limit }.
     * Ответы /cart/* при самовывозе его не несут — держим последний.
     */
    let lastPickupFreeDelivery = null;

    /** Порог, начиная с которого способ доставки считается «невменяемым» и в прогресс-бар не идёт, как в старой корзине */
    const INSANE_FREE_THRESHOLD = 100000;

    /**
     * Прогресс-бар бесплатной доставки (.delivery-progress-wrapper, free_delivery_progress_bar.php).
     * Логика старой корзины (retail_rocket_new_cart.js: totalPrice + updateDeliveryProgress) на данных новой:
     *  - курьер: отмеченные товары группируются по выбранному способу (радио data-free — порог free_delivery
     *    из delivery/list), способы с порогом от INSANE_FREE_THRESHOLD пропускаются; показывается способ,
     *    которому меньше всего осталось до бесплатной, если все уже бесплатные — первый;
     *  - самовывоз: бар виден, пока товар везут из другого магазина (или магазин не выбран), порог — free_limit.
     * Сумма — цена со скидкой × количество, без услуг: так порог считают курьерский сервис
     * (CourierService::calculateItemsDeliveryPrice) и StoreDeliveryStrategy.
     */
    function renderDeliveryProgress() {
        let totalSumAll = 0;
        const deliveryTypes = {};

        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const checkbox = product.querySelector('.product-checked');
            if (!checkbox || !checkbox.checked) {
                return;
            }

            const quantityInput = product.querySelector('.btns-quantity .qty-value');
            const quantity = parseFloat(quantityInput ? quantityInput.value : 0) || 0;
            const price = parseFloat(product.dataset.price) || 0;
            totalSumAll += price * quantity;

            const deliveryInput = product.querySelector('.prod-delivery input[type="radio"]:checked');
            if (!deliveryInput) {
                return;
            }

            const free = parseFloat(deliveryInput.dataset.free) || 0;
            if (free >= INSANE_FREE_THRESHOLD) {
                return;
            }

            const deliveryValue = deliveryInput.value;
            if (!deliveryTypes[deliveryValue]) {
                deliveryTypes[deliveryValue] = { sum: 0, free: free };
            }
            deliveryTypes[deliveryValue].sum += price * quantity;
        });

        if (isPickupSelected()) {
            if (!lastPickupFreeDelivery || !lastPickupFreeDelivery.delivered_from_another_store) {
                updateDeliveryProgress(totalSumAll, 0);
            } else {
                updateDeliveryProgress(totalSumAll, lastPickupFreeDelivery.free_limit);
            }

            return;
        }

        // Находим способ доставки, которому меньше всего осталось до бесплатной
        let selectedForProgress = null;
        let minRemaining = Infinity;
        Object.keys(deliveryTypes).forEach(function (key) {
            const remaining = Math.max(0, deliveryTypes[key].free - deliveryTypes[key].sum);
            if (remaining < minRemaining && remaining > 0) {
                minRemaining = remaining;
                selectedForProgress = deliveryTypes[key];
            }
        });

        // Если все доставки уже бесплатные (remaining = 0), показываем первую
        if (!selectedForProgress && Object.keys(deliveryTypes).length > 0) {
            selectedForProgress = deliveryTypes[Object.keys(deliveryTypes)[0]];
        }

        if (selectedForProgress) {
            updateDeliveryProgress(selectedForProgress.sum, selectedForProgress.free);
        } else {
            // Нет способов доставки (нет города, ничего не отмечено) — бар скрыт
            updateDeliveryProgress(0, 0);
        }
    }

    /**
     * Заполняет прогресс-бар; без порога или с набранной суммой прячет его. Перенесена из старой корзины как есть.
     */
    function updateDeliveryProgress(totalSum, freeLimit) {
        const progress = document.querySelector('.js-delivery-progress'),
            text = document.querySelector('.delivery-text'),
            textMob = document.querySelector('.delivery-text-mob'),
            progressMob = document.querySelector('.progress-bar-wrapper .sector'),
            price = document.querySelector('.delivery-price'),
            priceFree = document.querySelector('.delivery-price-free'),
            container = document.querySelector('.delivery-t'),
            progressBlock = document.querySelector('.delivery-progress-wrapper');
        if (!progressBlock) {
            return;
        }
        if (!progress || !freeLimit || freeLimit <= 0) {
            if (progress) progress.value = 0;
            progressBlock.classList.add('uk-hidden');
            return;
        }
        totalSum = parseFloat(totalSum) || 0;
        freeLimit = parseFloat(freeLimit) || 0;
        progress.max = freeLimit;
        progress.value = Math.min(totalSum, freeLimit);
        if (totalSum >= freeLimit) {
            progressBlock.classList.add('uk-hidden');
        } else {
            progressBlock.classList.remove('uk-hidden');
            const remaining = Math.max(0, freeLimit - totalSum).toFixed(0);
            if (text && container) {
                const template = container.dataset.text;
                let percent = freeLimit > 0 ? (totalSum / freeLimit) * 100 : 0;
                text.innerHTML = template.replace('%s', '<strong>' + remaining + '</strong>');
                if (textMob) textMob.innerText = remaining;
                percent = Math.min(100, Math.max(0, percent)).toFixed(0);
                if (progressMob) progressMob.style.setProperty('--percent', percent);
            }
            if (price) {
                price.innerText = totalSum.toLocaleString('ru-RU');
            }
            if (priceFree) {
                priceFree.innerText = freeLimit.toLocaleString('ru-RU');
            }
        }
    }

    const PROMO_BLOCK_SELECTOR = '.cart-total-block .block_promo_code';

    /**
     * Блок промокода: применённый (код, скидка, «Удалить») или поле ввода; строка «Промо код» в итогах.
     * appliedPromo — applied_promo из ответа: { code, applicable_discount } или null.
     */
    function renderPromoState(appliedPromo) {
        const block = document.querySelector(PROMO_BLOCK_SELECTOR);
        if (!block) {
            return;
        }

        const isApplied = !!(appliedPromo && appliedPromo.code);
        const appliedBlock = block.querySelector('.promo-applied');
        const applyBlock = block.querySelector('.promo-apply');
        if (appliedBlock) {
            appliedBlock.classList.toggle('uk-hidden', !isApplied);
        }
        if (applyBlock) {
            applyBlock.classList.toggle('uk-hidden', isApplied);
        }

        const discount = isApplied ? formatPrice(appliedPromo.applicable_discount) : '0';
        const code = block.querySelector('.promo-applied-code');
        if (code) {
            code.textContent = isApplied ? appliedPromo.code : '';
        }
        const appliedDiscount = block.querySelector('.promo-applied-discount');
        if (appliedDiscount) {
            appliedDiscount.textContent = discount;
        }

        const promoRow = document.querySelector('.cart-total-block .price_promo');
        if (promoRow) {
            promoRow.classList.toggle('uk-hidden', !isApplied);
        }
        setText('.order-promo-discount', discount);

        if (isApplied) {
            const input = block.querySelector('.promo-code-input');
            if (input) {
                input.value = '';
            }
            showPromoMessage('');
        }

        syncPromoUdsExclusion();
    }

    const UDS_BLOCK_SELECTOR = '.cart-total-block .block_uds_points';

    /**
     * Баллы Bomba Club доступны вошедшему покупателю (data-available); гостю поле отключено («Bomba Club недоступен»).
     */
    function isUdsAvailable() {
        const block = document.querySelector(UDS_BLOCK_SELECTOR);

        return !!(block && block.dataset.available === '1');
    }

    function getUdsMaxPoints() {
        const label = document.querySelector(UDS_BLOCK_SELECTOR + ' .total-points-use');

        return Math.max(0, parseInt(label && label.dataset.uds_points, 10) || 0);
    }

    /**
     * Введённые баллы: только цифры и не больше доступных (как clampUdsPointsInput в старой корзине).
     */
    function clampUdsPoints() {
        const input = document.getElementById('uds_code_y');
        if (!input) {
            return;
        }

        const digits = String(input.value || '').replace(/\D/g, '');
        const maxPoints = getUdsMaxPoints();
        input.value = digits && maxPoints > 0 ? String(Math.min(parseInt(digits, 10) || 0, maxPoints)) : '';
    }

    /**
     * Баллы, которые снимаются с заказа: 0 у гостя, при отключённом или скрытом поле.
     */
    function getUdsPoints() {
        const input = document.getElementById('uds_code_y');
        const block = document.querySelector(UDS_BLOCK_SELECTOR);
        if (!input || input.disabled || !block || block.classList.contains('uk-hidden')) {
            return 0;
        }

        return parseInt(input.value, 10) || 0;
    }

    /**
     * uds_max_points из итогов (CartProductService::getUdsMaxPoints): подпись «Доступно для использования»,
     * плейсхолдер и отключение поля, когда баллов нет. null — гость, поле не трогаем.
     */
    function syncUdsMaxPoints(maxPoints) {
        if (maxPoints === null || maxPoints === undefined || !isUdsAvailable()) {
            return;
        }

        const label = document.querySelector(UDS_BLOCK_SELECTOR + ' .total-points-use');
        if (label) {
            label.dataset.uds_points = Math.max(0, parseInt(maxPoints, 10) || 0);
        }

        const input = document.getElementById('uds_code_y');
        if (input) {
            const hasPoints = getUdsMaxPoints() > 0;
            input.placeholder = hasPoints ? (input.dataset.defaultPlaceholder || '') : (input.dataset.emptyPlaceholder || '');
            clampUdsPoints();
        }

        syncPromoUdsExclusion();
    }

    /**
     * Промокод и баллы Bomba Club вместе нельзя (RetailRocketCheckout отклонит заказ), как в старой корзине:
     *  - промокод применён или вводится — блок баллов скрыт, баллы сброшены;
     *  - баллы введены — блок промокода скрыт.
     */
    function syncPromoUdsExclusion() {
        const promoBlock = document.querySelector(PROMO_BLOCK_SELECTOR);
        const udsBlock = document.querySelector(UDS_BLOCK_SELECTOR);
        const udsInput = document.getElementById('uds_code_y');
        if (!promoBlock || !udsBlock || !udsInput || !isUdsAvailable()) {
            return;
        }

        const appliedBlock = promoBlock.querySelector('.promo-applied');
        const promoInput = promoBlock.querySelector('.promo-code-input');
        const isPromoApplied = !!(appliedBlock && !appliedBlock.classList.contains('uk-hidden'));
        const isPromoTyped = !!(promoInput && promoInput.value.trim());

        const isUdsBlocked = isPromoApplied || isPromoTyped;
        if (isUdsBlocked) {
            udsInput.value = '';
        }
        udsBlock.classList.toggle('uk-hidden', isUdsBlocked);
        udsBlock.classList.toggle('uds-disabled-by-promo', isPromoApplied);
        udsInput.disabled = isUdsBlocked || getUdsMaxPoints() <= 0;

        const isUdsTyped = !isUdsBlocked && udsInput.value.trim() !== '';
        promoBlock.classList.toggle('uk-hidden', isUdsTyped);
        promoBlock.classList.toggle('promo-disabled-by-uds', isUdsTyped);
    }

    /**
     * Итоги с новыми баллами — из последнего ответа, без запроса.
     */
    function renderTotalsWithUdsPoints() {
        if (lastOrderTotals) {
            renderOrderTotals(lastOrderTotals);
        }
    }

    /**
     * Поле баллов Bomba Club и крестик .clear-input-uds, как в старой корзине.
     */
    function initUdsPoints() {
        const input = document.getElementById('uds_code_y');
        if (!input || !isUdsAvailable()) {
            return;
        }

        input.addEventListener('input', function () {
            clampUdsPoints();
            syncPromoUdsExclusion();
            renderTotalsWithUdsPoints();
        });

        input.addEventListener('keydown', function (event) {
            // Enter в поле не отправляет форму заказа
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });

        const clearButton = document.querySelector(UDS_BLOCK_SELECTOR + ' .clear-input-uds');
        if (clearButton) {
            clearButton.addEventListener('click', function () {
                input.value = '';
                syncPromoUdsExclusion();
                renderTotalsWithUdsPoints();
            });
        }

        // Пока вводится промокод, баллы недоступны
        const promoInput = document.querySelector(PROMO_BLOCK_SELECTOR + ' .promo-code-input');
        if (promoInput) {
            promoInput.addEventListener('input', function () {
                syncPromoUdsExclusion();
                renderTotalsWithUdsPoints();
            });
        }

        syncPromoUdsExclusion();
    }

    /**
     * Ошибка под полем промокода. messageHtml — готовая разметка с сервера (ссылка «Войдите»).
     */
    function showPromoMessage(text, html) {
        const message = document.querySelector(PROMO_BLOCK_SELECTOR + ' .promo-message');
        if (!message) {
            return;
        }

        if (html) {
            message.innerHTML = html;
        } else {
            message.textContent = text || '';
        }
        message.classList.toggle('uk-hidden', !text && !html);
    }

    /**
     * Итоги после смены промокода: доставку пересчитываем тем же способом, что и при её выборе —
     * самовывоз по магазину, курьер по выбранным у товаров способам или по городу.
     * false — доставка не пересчитывалась (нет города), итоги из ответа промокода окончательные.
     */
    function refreshTotalsWithDelivery() {
        if (isPickupSelected()) {
            loadStoreTotals();

            return true;
        }

        if (loadDeliveryPrice()) {
            return true;
        }

        const cityId = getSelectValue(SELECT_LOCATION_ID);
        if (cityId) {
            refreshDelivery(cityId);

            return true;
        }

        return false;
    }

    /**
     * Ответ apply_promo / remove_promo: totals — итоги без доставки. Если доставка пересчитывается,
     * итоги нарисует её ответ, пока блоки размыты; иначе рисуем эти.
     */
    function renderPromoTotals(result) {
        renderPromoState(result.valid ? { code: result.code, applicable_discount: result.discount } : null);

        if (!refreshTotalsWithDelivery() && result.totals) {
            renderOrderTotals(Object.assign({ success: true }, result.totals));
        }
    }

    /**
     * onResult(result) вызывается до снятия блюра: пересчёт доставки начинается, пока блоки ещё размыты.
     */
    function sendPromoRequest(url, body, onResult) {
        return withLoading(fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                onResult(result);

                return result;
            }));
    }

    /**
     * Промокод, как в старой корзине: POST code на /{lang}/cart/apply_promo/ (RetailRocketCart::applyPromo),
     * «Удалить» — /{lang}/cart/remove_promo/. Код — только буквы, цифры, «-» и «_».
     * Скидку в итогах считает сервер (CartProductService) по промокоду из сессии.
     */
    function initPromoCode() {
        const block = document.querySelector(PROMO_BLOCK_SELECTOR);
        if (!block) {
            return;
        }

        const input = block.querySelector('.promo-code-input');
        const applyButton = block.querySelector('.promo-apply-btn');
        const removeButton = block.querySelector('.promo-remove');

        const applyPromo = function () {
            const code = (input ? input.value : '').trim();
            if (!code || applyButton.disabled) {
                return;
            }

            if (!/^[A-Za-z0-9_-]+$/.test(code)) {
                showPromoMessage(block.dataset.invalidFormatText);

                return;
            }

            showPromoMessage('');
            applyButton.disabled = true;
            sendPromoRequest(block.dataset.applyUrl, 'code=' + encodeURIComponent(code), function (result) {
                if (!result || !result.valid) {
                    showPromoMessage(result && result.message, result && result.messageHtml);

                    return;
                }

                renderPromoTotals(result);
            })
                .catch(function (error) {
                    console.warn('cart_checkout: не удалось применить промокод', error);
                    showPromoMessage(block.dataset.errorText);
                })
                .then(function () {
                    applyButton.disabled = false;
                });
        };

        if (applyButton) {
            applyButton.addEventListener('click', applyPromo);
        }

        if (input) {
            input.addEventListener('keydown', function (event) {
                // Enter в поле не отправляет форму заказа, а применяет промокод
                if (event.key === 'Enter') {
                    event.preventDefault();
                    applyPromo();
                }
            });
            input.addEventListener('input', function () {
                showPromoMessage('');
            });
        }

        if (removeButton) {
            removeButton.addEventListener('click', function () {
                if (removeButton.disabled) {
                    return;
                }

                removeButton.disabled = true;
                sendPromoRequest(block.dataset.removeUrl, '', function (result) {
                    if (result && result.removed) {
                        renderPromoTotals(result);
                    }
                })
                    .catch(function (error) {
                        console.warn('cart_checkout: не удалось удалить промокод', error);
                    })
                    .then(function () {
                        removeButton.disabled = false;
                    });
            });
        }
    }

    // cart:updated срабатывает до снятия блюра — итоги обновляются, пока блок ещё размыт.
    // В ответах /cart/* доставка курьерская; при самовывозе итоги пересчитываем по магазину
    document.addEventListener('cart:updated', function (event) {
        if (isPickupSelected()) {
            if (event.detail && event.detail.success) {
                loadStoreTotals();
            }
            // Количество поменялось — остатка магазина может уже не хватать
            syncProductsPickupText();

            return;
        }

        renderOrderTotals(event.detail);
    });

    /**
     * «Выбрать все»: отмечает или снимает все товары и сохраняет выбор.
     */
    function initCheckAll() {
        const checkAll = document.querySelector('.cart_form_send .input-checked.checked-all');
        if (!checkAll) {
            return;
        }

        checkAll.addEventListener('change', function () {
            const isChecked = checkAll.checked;
            document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
                product.classList.toggle('checked', isChecked);
                const productCheckbox = product.querySelector('.product-checked');
                if (productCheckbox) {
                    productCheckbox.checked = isChecked;
                }
            });

            syncCheckoutButton();
            syncOrderProductImages();

            if (!isChecked) {
                clearAllProductsDelivery();
            }

            updateAllProductsState(isChecked).then(function (result) {
                if (isChecked) {
                    renderAllProductsDelivery(result);
                }
            });
        });
    }

    /**
     * Все блоки способов доставки товаров: .prod-delivery[data-product=<product_id>].
     */
    function getProductDeliveryBlocks() {
        return document.querySelectorAll('.cart_form_send .block-product .prod-delivery');
    }

    /**
     * Снятые товары не доставляются — убираем их способы доставки.
     */
    function clearAllProductsDelivery() {
        getProductDeliveryBlocks().forEach(function (deliveryBlock) {
            deliveryBlock.innerHTML = '';
        });
        renderDeliveryIntervals();
    }

    /**
     * Часы в формате макета: 9 → «9:00».
     */
    function formatHour(hour) {
        return hour + ':00';
    }

    /**
     * Карточка способа доставки по макету:
     * <div style="display: block;" class="uk-first-column">
     *     <label class="filter_s">Standart
     *         <span class="time">24 ore</span>
     *         <span class="info">9:00 – 21:00</span>
     *         <input type="radio" data-id="0" checked name="type_delivery_item[<product_id>]" value="<delivery id>">
     *     </label>
     * </div>
     * uk-first-column и checked — только у первой карточки. Текст из ответа ставится через textContent.
     */
    function createDeliveryMethodItem(method, index, productId, hoursText) {
        const item = document.createElement('div');
        item.style.display = 'block';
        if (index === 0) {
            item.className = 'uk-first-column';
        }

        const label = document.createElement('label');
        label.className = 'filter_s';
        label.appendChild(document.createTextNode(method.name || ''));

        // Пробелы между узлами, как в разметке макета: «Standart 24 ore 9:00 – 21:00»
        const appendSpan = function (className, text) {
            label.appendChild(document.createTextNode(' '));
            const span = document.createElement('span');
            span.className = className;
            span.textContent = text;
            label.appendChild(span);
        };

        // Срок 0 или null — не показываем
        if (method.delivery_duration) {
            appendSpan('time', method.delivery_duration + ' ' + hoursText);
        }

        let info = '';
        if (method.delivery_from !== null && method.delivery_from !== undefined
            && method.delivery_to !== null && method.delivery_to !== undefined) {
            info = formatHour(method.delivery_from) + ' – ' + formatHour(method.delivery_to);
        }
        appendSpan('info', info);

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.dataset.id = index;
        radio.name = 'type_delivery_item[' + productId + ']';
        radio.value = method.id;
        radio.defaultChecked = index === 0;
        // Порог бесплатной доставки способа (free_delivery, добавляет CartProductService) — для прогресс-бара
        radio.dataset.free = method.free_delivery || 0;
        // Тексты способа для блоков под товаром (renderProductDeliveryTexts).
        // data-lift-floor — по нему style_cart.css показывает .block-lift-floor и «Ridicare la etaj»
        if (method.getting_up_text) {
            radio.dataset.liftFloor = '1';
            radio.dataset.gettingUpText = method.getting_up_text;
        }
        if (method.label) {
            radio.dataset.label = method.label;
        }
        // Интервалы для select[name="delivery_date"] (renderDeliveryIntervals): { 'd.m.y': [{ id, hour_from, hour_to }] }
        radio.dataset.methodName = method.name || '';
        radio.dataset.intervals = JSON.stringify(method.intervals || {});
        label.appendChild(document.createTextNode(' '));
        label.appendChild(radio);

        item.appendChild(label);

        return item;
    }

    /**
     * Способы доставки по товарам: { product_id: delivery_methods }.
     * Принимает ответ сервиса целиком ({code, data}), сразу data или {success, data} от ajax/cart/delivery/list.
     */
    function getDeliveryMethodsByProductId(deliveryList) {
        let deliveryData = deliveryList || {};
        if (deliveryData.data) {
            deliveryData = deliveryData.data;
        }

        const methodsByProductId = {};
        (deliveryData.products || []).forEach(function (product) {
            methodsByProductId[product.product_id] = product.delivery_methods || [];
        });

        return methodsByProductId;
    }

    /**
     * Перерисовывает способы доставки одного товара.
     */
    function renderProductDelivery(deliveryBlock, methods) {
        const productId = deliveryBlock.dataset.product;
        const hoursText = deliveryBlock.dataset.hoursText || '';

        deliveryBlock.innerHTML = '';
        methods.forEach(function (method, index) {
            deliveryBlock.appendChild(createDeliveryMethodItem(method, index, productId, hoursText));
        });

        renderProductDeliveryTexts(deliveryBlock.closest('.block-product'));
        renderDeliveryIntervals();
        renderDeliveryProgress();
    }

    /**
     * Интервалы доставки из delivery/list: первый непустой delivery_methods[].intervals по товарам
     * и их способам (радио хранят его в data-intervals). Дальше не ищем.
     * deliveryTypeId — способ, которому принадлежат интервалы: interval_id уходит только товарам с этим способом.
     * @return {{intervals: Object, methodName: string, deliveryTypeId: string}|null}
     */
    function findFirstDeliveryIntervals() {
        const radios = document.querySelectorAll('.cart_form_send .block-product .prod-delivery input[type="radio"]');
        for (let i = 0; i < radios.length; i++) {
            let intervals = {};
            try {
                intervals = JSON.parse(radios[i].dataset.intervals || '{}') || {};
            } catch (error) {
                continue;
            }

            if (!Array.isArray(intervals) && Object.keys(intervals).length) {
                return {
                    intervals: intervals,
                    methodName: radios[i].dataset.methodName || '',
                    deliveryTypeId: radios[i].value
                };
            }
        }

        return null;
    }

    /** Отложенный пересчёт по интервалу, выбранному автоматически */
    let intervalDeliveryPriceTimer = null;

    /**
     * delivery/price с автоматически выбранным интервалом. Список перестраивается по ходу отрисовки
     * способов у каждого товара — запрос уходит один раз, когда отрисованы все.
     */
    function scheduleIntervalDeliveryPrice() {
        clearTimeout(intervalDeliveryPriceTimer);
        intervalDeliveryPriceTimer = setTimeout(function () {
            // При самовывозе итоги считаются по магазину — курьерские не нужны
            if (!isPickupSelected()) {
                loadDeliveryPrice();
            }
        }, 0);
    }

    /** Час в формате интервала: 9 → «09:00» */
    function formatIntervalHour(hour) {
        return ('0' + (Number(hour) || 0)).slice(-2) + ':00';
    }

    /**
     * select[name="delivery_date"] из первого непустого intervals (findFirstDeliveryIntervals).
     * Ключ — дата «d.m.y», значение — интервалы дня. В заказ уходит «Y-d-m ЧЧ:ММ - ЧЧ:ММ», как в старой корзине.
     * Выбранный интервал сохраняется, если он есть в новом списке. Нет интервалов (Экспресс, регионы) —
     * блок скрыт, список отключён и не проверяется.
     */
    function renderDeliveryIntervals() {
        const select = document.querySelector('.cart_form_send select[name="delivery_date"]');
        if (!select) {
            return;
        }

        const found = findFirstDeliveryIntervals();
        const intervals = found ? found.intervals : {};

        const previousValue = select.value;
        const placeholder = select.querySelector('option[value=""]');
        select.innerHTML = '';
        if (placeholder) {
            select.appendChild(placeholder);
        }

        let hasIntervals = false;
        let hasPreviousValue = false;
        let firstOption = null;
        Object.keys(intervals).forEach(function (date) {
            const dayIntervals = intervals[date];
            const dateParts = date.split('.');
            if (!Array.isArray(dayIntervals) || !dayIntervals.length || dateParts.length !== 3) {
                return;
            }

            const group = document.createElement('optgroup');
            group.label = dateParts[0] + '.' + dateParts[1];
            const orderDate = '20' + dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1];
            dayIntervals.forEach(function (interval) {
                const time = formatIntervalHour(interval.hour_from) + ' - ' + formatIntervalHour(interval.hour_to);
                const option = document.createElement('option');
                option.value = orderDate + ' ' + time;
                option.textContent = time;
                option.dataset.intervalId = interval.id;
                if (!firstOption) {
                    firstOption = option;
                }
                if (option.value === previousValue) {
                    option.selected = true;
                    hasPreviousValue = true;
                }
                group.appendChild(option);
            });

            select.appendChild(group);
            hasIntervals = true;
        });

        // Интервалы есть — выбран первый (прежний выбор сохраняется, если он есть в новом списке);
        // интервалов нет — «Выберите»
        if (!hasPreviousValue) {
            if (firstOption) {
                firstOption.selected = true;
            } else if (placeholder) {
                placeholder.selected = true;
            }
        }

        select.disabled = !hasIntervals;
        select.dataset.deliveryTypeId = found ? found.deliveryTypeId : '';
        syncIntervalFormFields();

        // Интервал выбран сам — итоги пересчитываются с ним, как при выборе вручную
        if (hasIntervals && select.value !== previousValue) {
            scheduleIntervalDeliveryPrice();
        }
        // style_cart.css прячет блок без data-use-date у способа — показываем по has-intervals (new_cart.css)
        const block = select.closest('.block-slider-standart');
        if (block) {
            block.classList.toggle('has-intervals', hasIntervals);
            const methodName = block.querySelector('.delivery-interval-method');
            if (methodName && found && found.methodName) {
                methodName.textContent = found.methodName;
            }
        }
    }

    /**
     * Тексты выбранного у товара способа доставки (delivery_methods[] из delivery/list):
     * getting_up_text — в .block-lift-floor, label — в .text-delivery.
     * Тексты приходят HTML-ом от нашего курьерского сервиса и вставляются как есть.
     * label без своего списка разбивается по <br> на <li> (как в старой корзине).
     */
    function renderProductDeliveryTexts(product) {
        if (!product) {
            return;
        }

        const radio = product.querySelector('.prod-delivery input[type="radio"]:checked');

        const liftFloor = product.querySelector('.block-lift-floor');
        if (liftFloor) {
            liftFloor.innerHTML = radio && radio.dataset.gettingUpText ? radio.dataset.gettingUpText : '';
        }

        const textDelivery = product.querySelector('.text-delivery');
        if (!textDelivery) {
            return;
        }

        textDelivery.innerHTML = '';
        const label = radio && radio.dataset.label ? radio.dataset.label.trim() : '';
        if (!label) {
            return;
        }

        // Свой список в тексте — оставляем его, только помечаем для стилей (new_cart.css)
        if (/<(ul|ol)\b/i.test(label)) {
            textDelivery.innerHTML = label;
            textDelivery.querySelectorAll('ul, ol').forEach(function (list) {
                list.classList.add('delivery-label');
            });

            return;
        }

        const list = document.createElement('ul');
        list.className = 'delivery-label';
        label.split(/<br\s*\/?>/i).forEach(function (line) {
            if (!line.trim()) {
                return;
            }

            const item = document.createElement('li');
            item.innerHTML = line.trim();
            list.appendChild(item);
        });
        textDelivery.appendChild(list);
    }

    /**
     * Ставит каждому товару его способы доставки из delivery_list.products[].delivery_methods.
     */
    function renderAllProductsDelivery(result) {
        if (!result || !result.success || !result.delivery_list) {
            return;
        }

        const methodsByProductId = getDeliveryMethodsByProductId(result.delivery_list);
        getProductDeliveryBlocks().forEach(function (deliveryBlock) {
            renderProductDelivery(deliveryBlock, methodsByProductId[deliveryBlock.dataset.product] || []);
        });
    }

    /**
     * Галочка товара: POST /{lang}/cart/update-product-state/ (RetailRocketCart::updateProductState).
     * Как «Выбрать все»: в ответе итоги корзины (их рисует renderOrderTotals по cart:updated)
     * и доставки отмеченных товаров. Перерисовываем способы доставки только у этого товара,
     * у остальных выбранные способы не сбрасываются.
     */
    function updateProductState(productId, isChecked) {
        let body = 'id=' + encodeURIComponent(productId)
            + '&checked=' + (isChecked ? 1 : 0)
            + '&city_id=' + encodeURIComponent(getSelectValue(SELECT_LOCATION_ID))
            + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0);

        // Способы, выбранные у остальных отмеченных товаров: итоги считаются по ним
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            if (product.dataset.productId === String(productId)) {
                return;
            }

            const productCheckbox = product.querySelector('.product-checked');
            const deliveryRadio = product.querySelector('.prod-delivery input[type="radio"]:checked');
            if (productCheckbox && productCheckbox.checked && deliveryRadio && deliveryRadio.value) {
                body += '&delivery_types[' + encodeURIComponent(product.dataset.productId) + ']=' + encodeURIComponent(deliveryRadio.value);
            }
        });

        return sendCartUpdate('cart/update-product-state/', 'application/x-www-form-urlencoded', body, function (result) {
            if (!result || !result.success) {
                return;
            }

            const deliveryBlock = document.querySelector('.cart_form_send .block-product[data-product-id="' + productId + '"] .prod-delivery');
            if (!deliveryBlock) {
                return;
            }

            // Снятый товар не доставляется; отмеченный — его способы из ответа
            const methods = isChecked
                ? (getDeliveryMethodsByProductId(result.delivery_list)[productId] || [])
                : [];
            renderProductDelivery(deliveryBlock, methods);
        });
    }

    /**
     * «Выбрать все» отмечен, только когда отмечены все товары.
     */
    function syncCheckAll() {
        const checkAll = document.querySelector('.cart_form_send .input-checked.checked-all');
        if (!checkAll) {
            return;
        }

        const productCheckboxes = document.querySelectorAll('.cart_form_send .block-product .product-checked');
        let isAllChecked = productCheckboxes.length > 0;
        productCheckboxes.forEach(function (productCheckbox) {
            if (!productCheckbox.checked) {
                isAllChecked = false;
            }
        });

        checkAll.checked = isAllChecked;
    }

    /**
     * Картинки в блоке итогов «Товары»: видны только отмеченные товары,
     * блок целиком скрыт, если ничего не отмечено.
     */
    function syncOrderProductImages() {
        const imagesBlock = document.querySelector('.cart-total-block .block-img');
        if (!imagesBlock) {
            return;
        }

        const checkedProductIds = [];
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const productCheckbox = product.querySelector('.product-checked');
            if (productCheckbox && productCheckbox.checked) {
                checkedProductIds.push(product.dataset.productId);
            }
        });

        // Как в старой корзине: до 5 картинок; больше 5 товаров — 4 картинки и «+N».
        // Правило max-count из style_cart.css (nth-child) не подходит: картинки снятых товаров остаются в блоке
        const maxImages = checkedProductIds.length > 5 ? 4 : 5;
        imagesBlock.querySelectorAll('.product-image').forEach(function (image) {
            const position = checkedProductIds.indexOf(image.dataset.productId);
            image.classList.toggle('uk-hidden', position === -1 || position >= maxImages);
        });

        const count = imagesBlock.querySelector('.count');
        if (count) {
            const isOverflow = checkedProductIds.length > 5;
            count.textContent = isOverflow ? '+' + (checkedProductIds.length - maxImages) : '';
            count.style.display = isOverflow ? '' : 'none';
        }

        imagesBlock.classList.toggle('uk-hidden', !checkedProductIds.length);
    }

    /**
     * «Оформить заказ» виден, только если отмечен хотя бы один товар.
     */
    function syncCheckoutButton() {
        const checkoutButton = document.getElementById('checkout_btn');
        if (!checkoutButton) {
            return;
        }

        const hasChecked = document.querySelector('.cart_form_send .block-product .product-checked:checked') !== null;
        // Ничего не отмечено — кнопки нет; отмечена услуга без её товара — кнопка есть, но выключена
        checkoutButton.classList.toggle('uk-hidden', !hasChecked && !hasCheckedServices());
        const isBlocked = hasServicesWithoutProduct();
        checkoutButton.classList.toggle('uk-disabled', isBlocked);
        checkoutButton.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');

        // Ничего не отмечено — вместо «Оформить заказ» кнопка «Выбрать всё», «Удалить выбранные» неактивна
        const chooseAllButton = document.querySelector('.cart-total-block .btn_choose_all');
        if (chooseAllButton) {
            chooseAllButton.style.display = hasChecked ? 'none' : '';
        }

        const deleteButton = document.querySelector('.cart_form_send .js_delete_all');
        if (deleteButton) {
            deleteButton.classList.toggle('uk-disabled', !hasChecked);
        }
    }

    /**
     * Отмечена ли хоть одна услуга товара.
     */
    function hasCheckedServices() {
        return document.querySelector('.cart_form_send .cart-product-service input[type="checkbox"]:checked') !== null;
    }

    /**
     * Есть отмеченная услуга, товар которой не отмечен: такой заказ не оформляется.
     */
    function hasServicesWithoutProduct() {
        const products = document.querySelectorAll('.cart_form_send .block-product');
        for (let i = 0; i < products.length; i++) {
            const productCheckbox = products[i].querySelector('.product-checked');
            const hasCheckedService = products[i].querySelector('.cart-product-service input[type="checkbox"]:checked') !== null;
            if (hasCheckedService && !(productCheckbox && productCheckbox.checked)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Сводка блока услуг: «2 услуги +600 лей», отмеченные — is-checked, количество видно только у них.
     */
    function renderProductServicesSummary(servicesBlock) {
        const summary = servicesBlock.querySelector('.cart-product-services-summary');
        const summaryText = summary ? summary.querySelector('.cart-product-services-summary-text') : null;

        let count = 0;
        let total = 0;
        servicesBlock.querySelectorAll('.cart-product-service').forEach(function (service) {
            const checkbox = service.querySelector('input[type="checkbox"]');
            const qtySelect = service.querySelector('.cart-product-service-qty');
            const isChecked = !!(checkbox && checkbox.checked);

            service.classList.toggle('is-checked', isChecked);
            if (qtySelect) {
                qtySelect.style.visibility = isChecked ? 'visible' : 'hidden';
            }

            if (isChecked) {
                const quantity = parseInt(qtySelect && qtySelect.value, 10) || 1;
                count += quantity;
                total += (parseFloat(checkbox.dataset.price) || 0) * quantity;
            }
        });

        if (!summary || !summaryText) {
            return;
        }

        if (count > 0) {
            const label = count === 1 ? servicesBlock.dataset.servicesLabelSingular : servicesBlock.dataset.servicesLabelPlural;
            summaryText.textContent = count + ' ' + (label || '') + ' +' + formatPrice(total) + ' ' + (servicesBlock.dataset.lei || '');
            summary.style.visibility = 'visible';
        } else {
            summary.style.visibility = 'hidden';
        }
    }

    /**
     * Сохраняет выбранные услуги товара: POST /ajax/cart/services/sync (ajax-new/Cart::syncServices),
     * product_id и services[i][service_id|quantity]. Итоги с услугами пересчитываются с доставкой текущего способа;
     * без города — итоги из ответа (totals, без доставки).
     */
    function syncProductServices(servicesBlock) {
        const product = servicesBlock.closest('.block-product');
        if (!product || !product.dataset.productId) {
            return;
        }

        let body = 'product_id=' + encodeURIComponent(product.dataset.productId);
        let index = 0;
        servicesBlock.querySelectorAll('.cart-product-service').forEach(function (service) {
            const checkbox = service.querySelector('input[type="checkbox"]');
            if (!checkbox || !checkbox.checked) {
                return;
            }

            const qtySelect = service.querySelector('.cart-product-service-qty');
            body += '&services[' + index + '][service_id]=' + encodeURIComponent(checkbox.dataset.serviceId)
                + '&services[' + index + '][quantity]=' + encodeURIComponent(parseInt(qtySelect && qtySelect.value, 10) || 1);
            index++;
        });

        withLoading(fetch('/ajax/cart/services/sync', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                if (!result || !result.success) {
                    return result;
                }

                // Итоги рисуем до снятия блюра
                if (!refreshTotalsWithDelivery() && result.totals) {
                    renderOrderTotals(Object.assign({ success: true }, result.totals));
                }

                return result;
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось сохранить услуги', error);
            }));
    }

    /**
     * Услуги товаров, как в старой корзине: галочка и количество сохраняются с задержкой 300 мс
     * (несколько быстрых изменений — один запрос).
     */
    function initProductServices() {
        document.querySelectorAll('.cart_form_send .cart-product-services').forEach(function (servicesBlock) {
            renderProductServicesSummary(servicesBlock);

            let syncTimer = null;
            servicesBlock.querySelectorAll('.cart-product-service input[type="checkbox"], .cart-product-service-qty').forEach(function (input) {
                input.addEventListener('change', function () {
                    renderProductServicesSummary(servicesBlock);
                    syncCheckoutButton();

                    clearTimeout(syncTimer);
                    syncTimer = setTimeout(function () {
                        syncProductServices(servicesBlock);
                    }, 300);
                });
            });

            // «i» внутри label: подсказка, а не переключение услуги
            servicesBlock.querySelectorAll('.cart-product-service-info').forEach(function (info) {
                info.addEventListener('click', function (event) {
                    event.preventDefault();
                });
            });
        });
    }

    /**
     * «Выбрать всё» в блоке итогов отмечает все товары, как «Выбрать все» над списком.
     */
    function initChooseAllButton() {
        const chooseAllButton = document.querySelector('.cart-total-block .btn_choose_all');
        const checkAll = document.querySelector('.cart_form_send .input-checked.checked-all');
        if (!chooseAllButton || !checkAll) {
            return;
        }

        chooseAllButton.addEventListener('click', function () {
            if (!checkAll.checked) {
                checkAll.click();
            }
        });
    }

    /**
     * GA4 add_payment_info при выборе способа оплаты (ecommerce.js), как в старой корзине.
     */
    function initPaymentAnalytics() {
        document.querySelectorAll('.cart_form_send input[name="payment_type_id"]').forEach(function (input) {
            input.addEventListener('change', function () {
                if (typeof window.AddPaymentInfo === 'function') {
                    window.AddPaymentInfo(input.value);
                }
            });
        });
    }

    /**
     * Комментарий к заказу растёт по тексту (в старой корзине — onkeyup в разметке).
     */
    function initCommentAutosize() {
        const comment = document.querySelector('.cart_form_send textarea[name="message"]');
        if (!comment) {
            return;
        }

        comment.addEventListener('input', function () {
            comment.style.height = 'auto';
            comment.style.height = (comment.scrollHeight + 2) + 'px';
        });
    }

    /**
     * Галочка товара: отмечает товар и сохраняет выбор.
     * Сервер переключает is_checked товара по product_id.
     */
    function initProductCheck() {
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const productCheckbox = product.querySelector('.product-checked');
            const productId = product.dataset.productId;
            if (!productCheckbox || !productId) {
                return;
            }

            productCheckbox.addEventListener('change', function () {
                product.classList.toggle('checked', productCheckbox.checked);
                syncCheckAll();
                syncCheckoutButton();
                syncOrderProductImages();

                updateProductState(productId, productCheckbox.checked);
            });
        });
    }

    /**
     * Кнопки +/− у товара: количество считает сервер от значения в БД,
     * в ответе — новая строка товара и итоги корзины (getCartTotals).
     */
    function initQuantityButtons() {
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const productId = product.dataset.productId;
            const qtyInput = product.querySelector('.qty-value');
            const minusButton = product.querySelector('.btns-quantity .minus');
            const plusButton = product.querySelector('.btns-quantity .plus');
            if (!productId || !qtyInput || !minusButton || !plusButton) {
                return;
            }

            const onClick = function (change) {
                return function (event) {
                    // noOptimize.js тоже слушает .grid-cart .plus/.minus через document — не отдаём ему клик
                    event.stopPropagation();

                    // На минимуме «−» работает как удаление: спрашиваем в модалке
                    if (change === 'minus' && minusButton.classList.contains('delete')) {
                        openDeleteModal([productId]);

                        return;
                    }

                    changeProductQuantity(product, productId, change);
                };
            };

            minusButton.addEventListener('click', onClick('minus'));
            plusButton.addEventListener('click', onClick('plus'));
        });
    }

    function changeProductQuantity(product, productId, change) {
        const body = 'id=' + encodeURIComponent(productId)
            + '&with_totals=1'
            + '&city_id=' + encodeURIComponent(getSelectValue(SELECT_LOCATION_ID))
            + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0);

        // «+» → /{cos|korzina}/add/ (RetailRocketCart::increment), «−» → /{cos|korzina}/decrement/ (::decrement)
        const cartUri = getLang() === 'ru' ? 'korzina' : 'cos';
        const action = change === 'minus' ? 'decrement' : 'add';

        sendCartUpdate(cartUri + '/' + action + '/', 'application/x-www-form-urlencoded', body, function (result) {
            if (!result || !result.success) {
                return;
            }

            const qtyInput = product.querySelector('.qty-value');
            if (qtyInput) {
                qtyInput.value = result.quantity;
            }

            const minusButton = product.querySelector('.btns-quantity .minus');
            if (minusButton) {
                minusButton.classList.toggle('delete', result.quantity <= 1);
                minusButton.classList.toggle('delete-icon', result.quantity <= 1);
            }

            const itemPrice = product.querySelector('.block-product-price .price span');
            if (itemPrice) {
                itemPrice.textContent = result.item_total;
            }

            // Старая цена и скидка — тоже за всё количество (есть только у товаров со скидкой)
            const itemOldPrice = product.querySelector('.block-product-price .price_old');
            if (itemOldPrice) {
                itemOldPrice.textContent = result.item_old_total;
            }

            const itemSale = product.querySelector('.block-product-price .sale');
            if (itemSale) {
                itemSale.textContent = '−' + result.item_discount;
            }

            updateCartCounters(result);

            // Способы доставки зависят от количества — перерисовываем по ответу
            renderAllProductsDelivery(result);
        });
    }

    /**
     * Счётчик корзины в шапке и мини-корзина в подвале.
     */
    function updateCartCounters(result) {
        document.querySelectorAll('.cart_num').forEach(function (counter) {
            counter.setAttribute('data-count', result.cart_qty);
        });
        document.querySelectorAll('.qty').forEach(function (qty) {
            qty.textContent = result.cart_qty;
        });
        document.querySelectorAll('.total').forEach(function (total) {
            total.textContent = result.cart_total;
        });
    }

    const DELETE_MODAL_SELECTOR = '#modal-delete-check';

    /** Товары, которые удалит кнопка «Удалить» в модалке */
    let pendingDeleteProductIds = [];

    /**
     * Модалка удаления: один товар («Удалить товар») или несколько («Удалить товары»).
     */
    function openDeleteModal(productIds) {
        const modal = document.querySelector(DELETE_MODAL_SELECTOR);
        if (!modal || !productIds.length || !window.UIkit) {
            return;
        }

        pendingDeleteProductIds = productIds;

        const singleText = modal.querySelector('.content-item');
        const multipleText = modal.querySelector('.content-items');
        if (singleText && multipleText) {
            singleText.hidden = productIds.length > 1;
            multipleText.hidden = productIds.length <= 1;
        }

        window.UIkit.modal(modal).show();
    }

    /**
     * «Удалить выбранные», «−» на минимуме и кнопка «Удалить» в модалке.
     */
    function initDeleteModal() {
        const modal = document.querySelector(DELETE_MODAL_SELECTOR);
        if (!modal) {
            return;
        }

        const deleteAllButton = document.querySelector('.cart_form_send .js_delete_all');
        if (deleteAllButton) {
            deleteAllButton.addEventListener('click', function () {
                const checkedProductIds = [];
                document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
                    const productCheckbox = product.querySelector('.product-checked');
                    if (productCheckbox && productCheckbox.checked && product.dataset.productId) {
                        checkedProductIds.push(product.dataset.productId);
                    }
                });

                openDeleteModal(checkedProductIds);
            });
        }

        const confirmButton = modal.querySelector('.delete-check');
        if (confirmButton) {
            confirmButton.addEventListener('click', function () {
                const productIds = pendingDeleteProductIds;
                pendingDeleteProductIds = [];
                if (window.UIkit) {
                    window.UIkit.modal(modal).hide();
                }

                deleteProducts(productIds, confirmButton.dataset.url);
            });
        }
    }

    /**
     * Удаляет товары из корзины и со страницы; итоги и доставки — из ответа.
     * Если корзина опустела — перезагружаем страницу, её вид для пустой корзины рисует сервер.
     */
    function deleteProducts(productIds, deleteUrl) {
        if (!productIds.length) {
            return;
        }

        // data-url кнопки: /{lang}/{cos|korzina}/del/; sendCartUpdate сам добавляет /{lang}/
        let path = (getLang() === 'ru' ? 'korzina' : 'cos') + '/del/';
        if (deleteUrl) {
            path = deleteUrl.replace(/^\/[a-z]{2}\//, '');
        }

        let body = 'with_totals=1'
            + '&city_id=' + encodeURIComponent(getSelectValue(SELECT_LOCATION_ID))
            + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0);
        productIds.forEach(function (productId) {
            body += '&product_ids[]=' + encodeURIComponent(productId);
        });

        sendCartUpdate(path, 'application/x-www-form-urlencoded', body, function (result) {
            if (!result || !result.success) {
                return;
            }

            (result.product_ids || []).forEach(function (productId) {
                const product = document.querySelector('.cart_form_send .block-product[data-product-id="' + productId + '"]');
                if (product) {
                    product.remove();
                }

                const image = document.querySelector('.cart-total-block .block-img .product-image[data-product-id="' + productId + '"]');
                if (image) {
                    image.remove();
                }
            });

            if (!document.querySelector('.cart_form_send .block-product')) {
                window.location.reload();

                return;
            }

            updateCartCounters(result);
            syncCheckAll();
            syncCheckoutButton();
            syncOrderProductImages();
            renderAllProductsDelivery(result);
        });
    }

    /** Номер последнего запроса цены доставки: ответы на устаревшие запросы отбрасываем */
    let deliveryPriceRequestId = 0;

    /**
     * Выбор способа доставки (радио в .prod-delivery): цена доставки и итоги
     * для выбранных способов всех отмеченных товаров — /ajax/cart/delivery/price.
     * Радио рисуются после ответа доставок, поэтому слушаем через document.
     */
    function initDeliveryTypeChange() {
        document.addEventListener('change', function (event) {
            const radio = event.target;
            if (!radio.matches || !radio.matches('.cart_form_send .prod-delivery .filter_s input[type="radio"]')) {
                return;
            }

            renderProductDeliveryTexts(radio.closest('.block-product'));
            renderDeliveryProgress();
            loadDeliveryPrice();
        });
    }

    /**
     * Интервал из name="delivery_date" для delivery/price: interval_ids[product_id] только у отмеченных товаров,
     * у которых выбран способ, которому принадлежит интервал (select data-delivery-type-id).
     * Интервал не выбран — пустая строка.
     */
    function getSelectedIntervalId() {
        const select = document.querySelector('.cart_form_send select[name="delivery_date"]');
        if (!select || select.disabled || select.selectedIndex < 0 || !select.dataset.deliveryTypeId) {
            return '';
        }

        return select.options[select.selectedIndex].dataset.intervalId || '';
    }

    /**
     * Скрытые поля заказа delivery_interval_id / delivery_interval_type_id: по ним RetailRocketCheckout
     * считает цену доставки с интервалом (CourierDeliveryStrategy) — так же, как итоги на странице.
     */
    function syncIntervalFormFields() {
        const select = document.querySelector('.cart_form_send select[name="delivery_date"]');
        const intervalId = getSelectedIntervalId();

        const intervalInput = document.getElementById('delivery_interval_id');
        if (intervalInput) {
            intervalInput.value = intervalId;
        }

        const typeInput = document.getElementById('delivery_interval_type_id');
        if (typeInput) {
            typeInput.value = intervalId && select ? select.dataset.deliveryTypeId : '';
        }
    }

    function getIntervalRequestParams() {
        const select = document.querySelector('.cart_form_send select[name="delivery_date"]');
        const intervalId = getSelectedIntervalId();
        if (!intervalId) {
            return '';
        }

        let params = '';
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const productCheckbox = product.querySelector('.product-checked');
            const deliveryRadio = product.querySelector('.prod-delivery input[type="radio"]:checked');
            if (productCheckbox && productCheckbox.checked && deliveryRadio && deliveryRadio.value === select.dataset.deliveryTypeId) {
                params += '&interval_ids[' + encodeURIComponent(product.dataset.productId) + ']=' + encodeURIComponent(intervalId);
            }
        });

        return params;
    }

    /**
     * Выбор интервала в name="delivery_date": итоги пересчитываются по delivery/price с этим интервалом.
     */
    function initDeliveryIntervalChange() {
        const select = document.querySelector('.cart_form_send select[name="delivery_date"]');
        if (!select) {
            return;
        }

        select.addEventListener('change', function () {
            syncIntervalFormFields();
            loadDeliveryPrice();
        });
    }

    function loadDeliveryPrice() {
        let body = 'city_id=' + encodeURIComponent(getSelectValue(SELECT_LOCATION_ID))
            + '&lift_floor=' + (isLiftFloorChecked() ? 1 : 0)
            + '&lang=' + encodeURIComponent(getLang());

        let hasDeliveryTypes = false;
        document.querySelectorAll('.cart_form_send .block-product').forEach(function (product) {
            const productCheckbox = product.querySelector('.product-checked');
            const deliveryRadio = product.querySelector('.prod-delivery input[type="radio"]:checked');
            if (!productCheckbox || !productCheckbox.checked || !deliveryRadio || !deliveryRadio.value) {
                return;
            }

            hasDeliveryTypes = true;
            body += '&delivery_types[' + encodeURIComponent(product.dataset.productId) + ']=' + encodeURIComponent(deliveryRadio.value);
        });

        if (!hasDeliveryTypes) {
            return false;
        }

        body += getIntervalRequestParams();

        deliveryPriceRequestId++;
        const requestId = deliveryPriceRequestId;

        withLoading(fetch('/ajax/cart/delivery/price', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                // Итоги подставляем до снятия блюра
                if (requestId === deliveryPriceRequestId) {
                    renderOrderTotals(result);
                }

                return result;
            })
            .catch(function (error) {
                console.warn('cart_checkout: не удалось получить цену доставки', error);

                return null;
            }));

        return true;
    }

    /**
     * Шаги оформления заказа — пункты аккордеона .page-delivery:
     * «Адрес доставки» (при самовывозе скрыт), «Контактные данные», «Способ оплаты».
     */
    function getCheckoutSteps() {
        return document.querySelectorAll('.cart_form_send .page-delivery .uk-accordion > li');
    }

    /**
     * Открывает шаг через UIkit, чтобы аккордеон сам показал содержимое и закрыл остальные.
     */
    function openCheckoutStep(index) {
        const accordion = document.querySelector('.cart_form_send .page-delivery .uk-accordion');
        const steps = getCheckoutSteps();
        if (!accordion || !steps[index]) {
            return;
        }

        if (window.UIkit) {
            if (!steps[index].classList.contains('uk-open')) {
                window.UIkit.accordion(accordion).toggle(index, false);
            }

            return;
        }

        steps.forEach(function (step, stepIndex) {
            step.classList.toggle('uk-open', stepIndex === index);
        });
    }

    function scrollToElement(from, selector) {
        if (window.UIkit && document.querySelector(selector)) {
            window.UIkit.scroll(from, { offset: 100, duration: 500 }).scrollTo(selector);
        }
    }

    function notifyInputEmpty() {
        const pageDelivery = document.querySelector('.cart_form_send .page-delivery');
        if (window.UIkit && pageDelivery && pageDelivery.dataset.inputEmpty) {
            window.UIkit.notification(pageDelivery.dataset.inputEmpty, { pos: 'top-right', status: 'danger' });
        }
    }

    /**
     * Проверяет поля шага, как в старой корзине: required и формат (checkValidity),
     * имя и фамилия — не короче 3 символов. Неверные поля подсвечиваются form-danger.
     * onlyVisible — только видимые поля (кнопка «Далее» открытого шага); иначе все поля шага.
     */
    function validateCheckoutStep(step, onlyVisible) {
        let isValid = true;
        step.querySelectorAll('input, select, textarea').forEach(function (input) {
            if (input.disabled || input.type === 'hidden' || (onlyVisible && input.offsetParent === null)) {
                return;
            }

            const isNameTooShort = (input.name === 'name' || input.name === 'lastName') && input.value.trim().length < 3;
            const isInputValid = input.checkValidity() && !isNameTooShort;
            input.classList.toggle('form-danger', !isInputValid);
            if (!isInputValid) {
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * Краткая сводка шага в .hidden-span (видна, когда шаг свёрнут на page-2).
     */
    function fillCheckoutSummary() {
        document.querySelectorAll('.cart_form_send .page-delivery .dynamic-input, .cart_form_send .page-delivery .dynamic-select-date').forEach(function (block) {
            const input = block.querySelector('input, textarea, select');
            const hiddenSpan = block.querySelector('.hidden-span');
            if (!input || !hiddenSpan) {
                return;
            }

            let value = input.value || input.placeholder || '';
            // Интервал доставки: «18.09 09:00 - 15:00» вместо значения для заказа
            if (input.tagName === 'SELECT' && input.selectedIndex > 0) {
                const option = input.options[input.selectedIndex];
                const group = option.parentNode && option.parentNode.tagName === 'OPTGROUP' ? option.parentNode.label + ' ' : '';
                value = group + option.textContent;
            }
            if (input.id === 'phone') {
                value = value.replace(/\D/g, '');
                if (value.length > 8) {
                    value = '0' + value.slice(-8);
                }
            }

            hiddenSpan.textContent = value;
        });
    }

    /**
     * Город (курьер) или магазин (самовывоз) выбран — без них заказ не оформить.
     * Если нет — страница затемняется с подсказкой (onSelectChange) и прокручивается к выбору.
     */
    function ensureDeliveryPlaceChosen(from) {
        onSelectChange();
        const selectId = isPickupSelected() ? SELECT_SHOP_ID : SELECT_LOCATION_ID;
        if (getSelectValue(selectId)) {
            return true;
        }

        scrollToElement(from, '.block-delivery');

        return false;
    }

    /**
     * Самовывоз: подарок доставляет курьер — блок скрыт; оплата при доставке (.shop-hide) скрыта
     * в style_cart.css — если была выбрана она, выбираем первый доступный способ.
     */
    function syncPickupCheckoutFields(isPickup) {
        const gift = document.querySelector('.cart_form_send .page-delivery .block-gift');
        if (gift) {
            gift.classList.toggle('uk-hidden', isPickup);
        }

        if (!isPickup) {
            return;
        }

        const giftCheckbox = document.querySelector('.cart_form_send input[name="is_gift"]');
        if (giftCheckbox) {
            giftCheckbox.checked = false;
        }

        const checkedPayment = document.querySelector('.cart_form_send input[name="payment_type_id"]:checked');
        if (!checkedPayment || !checkedPayment.closest('.shop-hide')) {
            return;
        }

        const payments = document.querySelectorAll('.cart_form_send input[name="payment_type_id"]');
        for (let i = 0; i < payments.length; i++) {
            if (!payments[i].closest('.shop-hide')) {
                payments[i].checked = true;

                return;
            }
        }

        checkedPayment.checked = false;
    }

    /**
     * Оформление заказа, как в старой корзине:
     *  - «Оформить заказ» (#checkout_btn): при выбранном городе / магазине .switcher-content получает page-2;
     *  - «Изменить» / «Корзина» (.page-back) возвращают к списку товаров;
     *  - «Далее» проверяет поля шага и открывает следующий;
     *  - «Заказать» (#ordin-button) проверяет все шаги и согласия и отправляет форму в RetailRocketCheckout.
     */
    function initCheckoutSteps() {
        const wrapper = document.querySelector('.switcher-content');
        const form = document.querySelector('.cart_form_send');
        if (!wrapper || !form) {
            return;
        }

        const checkoutButton = document.getElementById('checkout_btn');
        if (checkoutButton) {
            checkoutButton.addEventListener('click', function (event) {
                event.preventDefault();
                if (!document.querySelector('.cart_form_send .block-product .product-checked:checked') && !hasCheckedServices()) {
                    return;
                }

                // Услуга без её товара — кнопка выключена (syncCheckoutButton)
                if (hasServicesWithoutProduct()) {
                    return;
                }

                if (!ensureDeliveryPlaceChosen(checkoutButton)) {
                    return;
                }

                wrapper.classList.add('page-2');
                scrollToElement(checkoutButton, '.block-delivery');
            });
        }

        document.querySelectorAll('.page-back').forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                wrapper.classList.remove('page-2');
            });
        });

        getCheckoutSteps().forEach(function (step, index) {
            const nextButton = step.querySelector('.next-button');
            if (!nextButton) {
                return;
            }

            nextButton.addEventListener('click', function (event) {
                event.preventDefault();
                if (!validateCheckoutStep(step, true)) {
                    notifyInputEmpty();

                    return;
                }

                fillCheckoutSummary();
                openCheckoutStep(index + 1);
                scrollToElement(nextButton, '.scroll-to .uk-accordion li.uk-open');
            });
        });

        const requiredCheckboxes = document.querySelectorAll('.block-pay input[type="checkbox"][required]');
        requiredCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                const label = checkbox.closest('.item-checkbox');
                if (label && checkbox.checked) {
                    label.classList.remove('is-invalid');
                }
            });
        });

        const orderButton = document.getElementById('ordin-button');
        if (!orderButton) {
            return;
        }

        orderButton.addEventListener('click', function (event) {
            event.preventDefault();
            // Услуга без её товара: вернуться к списку товаров, где кнопка «Оформить заказ» выключена
            if (hasServicesWithoutProduct()) {
                wrapper.classList.remove('page-2');

                return;
            }

            if (orderButton.disabled || !ensureDeliveryPlaceChosen(orderButton)) {
                return;
            }

            // Шаги можно открывать заголовками, минуя «Далее», — проверяем все, кроме скрытых (адрес при самовывозе)
            const steps = getCheckoutSteps();
            for (let i = 0; i < steps.length; i++) {
                if (steps[i].classList.contains('uk-hidden') || validateCheckoutStep(steps[i], false)) {
                    continue;
                }

                openCheckoutStep(i);
                notifyInputEmpty();
                scrollToElement(orderButton, '.scroll-to .uk-accordion li.uk-open');

                return;
            }

            let hasInvalidAgreement = false;
            requiredCheckboxes.forEach(function (checkbox) {
                const label = checkbox.closest('.item-checkbox');
                if (label) {
                    label.classList.remove('is-invalid');
                    if (!checkbox.checked) {
                        void label.offsetWidth; // перезапуск анимации встряхивания
                        label.classList.add('is-invalid');
                    }
                }

                if (!checkbox.checked) {
                    hasInvalidAgreement = true;
                }
            });

            if (hasInvalidAgreement) {
                return;
            }

            // Повторный клик до перехода на оплату создал бы второй заказ
            orderButton.disabled = true;
            fillCheckoutSummary();
            form.submit();
        });
    }

    /**
     * «Поднять на этаж»: цена подъёма входит в итоги — пересчитываем их с доставкой.
     */
    function initLiftFloor() {
        const liftFloor = document.querySelector('.cart_form_send input[name="lift_floor"]');
        if (!liftFloor) {
            return;
        }

        liftFloor.addEventListener('change', function () {
            refreshTotalsWithDelivery();
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initSelects();
        initPhoneInputs();
        initCheckAll();
        initProductCheck();
        initQuantityButtons();
        initDeleteModal();
        initDeliveryTypeChange();
        initDeliveryIntervalChange();
        initLocationConfirm();
        initDeliveryTypeSwitch();
        initShopConfirm();
        initPromoCode();
        initUdsPoints();
        initChooseAllButton();
        initProductServices();
        initPaymentAnalytics();
        initCommentAutosize();
        syncCheckoutButton();
        syncOrderProductImages();
        initCheckoutSteps();
        initLiftFloor();
        // Страница открыта с самовывозом (cookie type_delivery): оплата при доставке недоступна
        syncPickupCheckoutFields(isPickupSelected());
        loadAutomaticCity();

        // Страница приходит размытой (is-loading в разметке). Если доставки при загрузке
        // не запрашиваются (нет города, нет tom-select), снимаем блюр сразу,
        // иначе его снимет withLoading после ответа
        if (pendingCartUpdates === 0) {
            setTotalsLoading(false);
        }
    });
})();
